<script lang="ts">
  import { get } from 'svelte/store'

  import { clientPublicStore, forcedPageStore, pageStore, userStore } from '@packages/stores'
  import { Pages } from '@packages/utils/enums'

  import { getProfileLinks } from '@pages/profile/Profile.service'

  import type { TProfileLinks } from '@packages/utils/types'

  import { Profile } from '@packages/ui'
  import { getAddress, getBalance } from '@src/passport/blockchain'
  import { configStore } from '@src/stores/config'

  let links: TProfileLinks = {} as TProfileLinks
  let balance: string | null = null
  let gitbookToken: string | null = null

  const getProfileInfo = async () => {
    const publicKey = await getAddress()
    links = getProfileLinks(publicKey)

    if ($configStore.buyTokens !== false) {
      try {
        balance = `${await getBalance()} ${$clientPublicStore?.ui_settings.cred_alias || 'cred'}`
      } catch (err) {
        balance = '-'
      }
    }
  }

  $: getProfileInfo()

</script>

<Profile
  options={{
    links,
    gitbookToken,
    gitbookUrl: get(configStore).credenza.gitbookUrl,
    onSignOut: () => pageStore.set(Pages.LOGOUT),
    onUpdateProfile: () => forcedPageStore.set(Pages.UPDATE_PROFILE),
    balance,
    storedValueAlias: $clientPublicStore.ui_settings.stored_value_alias,
    userData: $userStore,
    userAddress: getAddress(),
  }}
/>
